import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { IndentReceiveHeaderData, IndentReceiveHeader } from '../../../interfaces/pharmacy/IndentReceiveHeader';
import { IndentReceApi } from '../api/Indentrec.api';

@Injectable() 
export class IndentReceiveService extends IndentReceiveHeaderData{
 
  constructor(private api: IndentReceApi) {
    super();
  } 
  
  getall(url: string): Observable<IndentReceiveHeader[]> { 
    return this.api.getall(url);
  } 

  getById(url:string): Observable<IndentReceiveHeader>{
      return this.api.getby_id(url);
  }

  create(url: string, data:IndentReceiveHeader): Observable<IndentReceiveHeader[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:IndentReceiveHeader): Observable<IndentReceiveHeader> { 
    return this.api.update(url,data);
  }  

  list(url: string): Observable<any> {
    return this.api.list(url);
  }

  searchList(url: string,data:any): Observable<any> {  
    return this.api.searchList(url,data);
  }
}
